<!-- 用户中心 -->
<template>
    <div>
        <admin-main-header>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'Forward', params: {target: 'Index'} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            </el-breadcrumb>
        </admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 个人中心</span>
                </div>
                <div class="admin-content-main">
                    <el-row>
                        <el-col :span="6">
                            <div class="admin-userhome-usercard">
                                <img :src="loginUser.userIconUrl" />
                                <h5>{{loginUser.userName}}</h5>
                                <h3>{{loginUser.nickName}}</h3>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <el-row>
                                <el-col :span="6">
                                    <div class="admin-userhome-infobox el-clearfix">
                                        <div class="el-col el-col-16">
                                            <h3>Roles</h3>
                                            <span>{{loginUser.roleBadges}}</span>
                                        </div>
                                        <div class="el-col el-col-8">
                                            <i class="fas fa-bars"></i>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="admin-userhome-infobox el-clearfix">
                                        <div class="el-col el-col-16">
                                            <h3>Messages</h3>
                                            <span>{{loginUser.messageBadges}}</span>
                                        </div>
                                        <div class="el-col el-col-8">
                                            <i class="fas fa-envelope"></i>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="admin-userhome-infobox el-clearfix">
                                        <div class="el-col el-col-16">
                                            <h3>Notices</h3>
                                            <span>{{loginUser.noticeBadges}}</span>
                                        </div>
                                        <div class="el-col el-col-8">
                                            <i class="fas fa-bell"></i>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="admin-userhome-infobox el-clearfix">
                                        <div class="el-col el-col-16">
                                            <h3>Logins</h3>
                                            <span>{{loginUser.loginTimes}}</span>
                                        </div>
                                        <div class="el-col el-col-8">
                                            <i class="fas fa-sign-in-alt"></i>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <el-tabs v-model="userActiveTabName">
                        <el-tab-pane label="基本信息" name="userBasicInfo">
                            <el-form class="el-form-detail" inline label-position="right" label-width="120px" label-suffix="：">
                                <el-form-item label="用户ID">{{loginUser.userId}}</el-form-item>
                                <el-form-item label="用户名">{{loginUser.userName}}</el-form-item>

                                <el-form-item label="昵  称">{{loginUser.nickName}}</el-form-item>
                                <el-form-item label="姓  名">{{loginUser.realName}}</el-form-item>

                                <el-form-item label="手机号码">{{loginUser.mobilePhone}}</el-form-item>
                                <el-form-item label="EMAIL">{{loginUser.email}}</el-form-item>

                                <el-form-item label="用户类型">
                                    <el-tag size="small" :type="getUserTypeTagType(loginUser.userType)">{{loginUser.userTypeName}}</el-tag>
                                </el-form-item>
                                <el-form-item label="状  态">
                                    <el-tag size="small" :type="getUserStatusTagType(loginUser.status)">{{loginUser.statusName}}</el-tag>
                                </el-form-item>

                                <el-form-item label="所属组织机构">
                                    <el-tag size="small" type="primary">{{loginUser.orgName}}</el-tag>
                                </el-form-item>
                                <el-form-item label="邀请码">
                                    <el-tag size="small" type="primary">{{loginUser.inviteCode}}</el-tag>
                                </el-form-item>

                                <el-form-item label="最后登录时间">{{loginUser.lastLoginTime}}</el-form-item>
                                <el-form-item label="登录总次数">{{loginUser.loginTimes}}</el-form-item>

                                <el-form-item label="创建时间">{{loginUser.createTime}}</el-form-item>
                                <el-form-item label="修改时间">{{loginUser.updateTime}}</el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="我的角色" name="userRoles">
                            <el-table class="el-table-overflow-x-hidden" :data="userRoleList" style="width:100%;" empty-text="暂无配置">
                                <el-table-column label="#" type="index" width="40"></el-table-column>
                                <el-table-column label="角色名称" prop="roleName" width="170"></el-table-column>
                                <el-table-column label="角色代码" prop="roleCode" width="170"></el-table-column>
                                <el-table-column label="角色类型" prop="roleType" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-tag size="small" :type="getRoleTypeTagType(scope.row.roleType)">{{scope.row.roleTypeName}}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="角色描述" prop="description"></el-table-column>
                                <el-table-column label="配置时间" prop="createTime" width="100" align="center"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="我的足迹" name="userAccessLogs">
                            <el-form ref="userAccessLogQueryForm" :model="userAccessLogQueryForm" style="padding: 5px 0 0;">
                                <el-row :gutter="20">
                                    <el-col :span="4" :offset="2">
                                        <el-form-item prop="logTitle">
                                            <el-input v-model="userAccessLogQueryForm.logTitle" :maxlength="100" placeholder="日志标题"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item class="el-inline-block el-align-right" prop="startAccessTime" style="width:40%;">
                                            <el-date-picker v-model="userAccessLogQueryForm.startAccessTime" type="datetime" placeholder="访问时间(开始)" value-format="yyyy-MM-ddTHH:mm:ss.SSSZ"></el-date-picker>
                                        </el-form-item>
                                        <span class="el-inline-block" style="width:10%;text-align:center;line-height:32px;vertical-align:top;"> ~ </span>
                                        <el-form-item class="el-inline-block el-align-left" prop="endAccessTime" style="width:40%;">
                                            <el-date-picker v-model="userAccessLogQueryForm.endAccessTime" type="datetime" placeholder="访问时间(结束)" value-format="yyyy-MM-ddTHH:mm:ss.SSSZ"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item class="el-align-center">
                                            <el-button @click="resetUserAccessLogQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <el-button type="primary" @click="queryUserAccessLogList(1000)" icon="fas fa-search">查 询</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <el-table ref="userAccessLogTable" v-loading="userAccessLogLoading" class="el-table-overflow-x-hidden" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: userAccessLogLoading}" :data="userAccessLogList" :default-sort="userAccessLogQuerySort" @sort-change="onUserAccessLogQuerySortChange" style="width:100%;" empty-text="暂无数据">
                                <el-table-column label="#" type="index" width="40"></el-table-column>
                                <el-table-column label="功能模块" prop="appModule" width="100" sortable></el-table-column>
                                <el-table-column label="日志标题" prop="logTitle" width="180" sortable></el-table-column>
                                <el-table-column label="请求URI" prop="requestUri" sortable></el-table-column>
                                <el-table-column label="请求方法" prop="httpMethod" width="100" sortable></el-table-column>
                                <el-table-column label="客户端IP" prop="clientIpAddr" width="100" align="center" sortable></el-table-column>
                                <el-table-column label="服务端IP" prop="serverIpAddr" width="160" align="center" sortable></el-table-column>
                                <el-table-column label="访问耗时" prop="processTime" width="100" align="center" :formatter="formatProcessTime" sortable></el-table-column>
                                <el-table-column label="访问时间" prop="accessTime" width="100" align="center" sortable></el-table-column>
                            </el-table>
                            <div class="el-search-pager">
                                <el-pagination background v-show="showAccessLogQueryPager" @current-change="onUserAccessLogQueryCurrentPageChange" :current-page.sync="userAccessLogQueryForm.currentPage" :page-size="userAccessLogQueryForm.pageSize" layout="slot, prev, pager, next, total" :total="userAccessLogQueryTotal">
                                    <div class="el-pagination-pagesize">
                                        <span class="first">每页显示</span>
                                        <el-button-group>
                                            <el-button :class="{active: userAccessLogQueryForm.pageSize == 10}" @click="onUserAccessLogQueryPageSizeChange(10);">10</el-button>
                                            <el-button :class="{active: userAccessLogQueryForm.pageSize == 20}" @click="onUserAccessLogQueryPageSizeChange(20);">20</el-button>
                                            <el-button :class="{active: userAccessLogQueryForm.pageSize == 50}" @click="onUserAccessLogQueryPageSizeChange(50);">50</el-button>
                                            <el-button :class="{active: userAccessLogQueryForm.pageSize == 100}" @click="onUserAccessLogQueryPageSizeChange(100);">100</el-button>
                                        </el-button-group>
                                        <span class="last">条</span>
                                    </div>
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

export default {
    name: 'UpmsUserCenter',
    data() {
        return {
            submiting: false,
            userActiveTabName: 'userBasicInfo',
            userRoleList: [],
            userAccessLogList: [],
            userAccessLogQuering: false,
            userAccessLogQueryForm: {
                logTitle: '',
                accessUserId: '',
                startAccessTime: '',
                endAccessTime: '',
                pageSize: 10,
                currentPage: 1
            },
            userAccessLogQuerySort: {
                prop: 'accessTime',
                order: 'descending'
            },
            userAccessLogQueryTotal: 0,
            userAccessLogLoading: false
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showAccessLogQueryPager() {
            if (
                this.userAccessLogQuering ||
                this.userAccessLogQueryTotal == 0
            ) {
                return false;
            } else {
                return true;
            }
        }
    },
    created() {},
    mounted() {
        this.queryUserRoleList();
        this.queryUserAccessLogList(0);
    },
    methods: {
        getUserTypeTagType(userType) {
            if (userType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        getUserStatusTagType(status) {
            if (status == 0) {
                return 'danger';
            } else {
                return 'success';
            }
        },
        getRoleTypeTagType(roleType) {
            if (roleType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        formatProcessTime(row, column) {
            return row.processTime + '毫秒';
        },
        queryUserRoleList() {
            let url = PLATFORM_API.of('/api/platform/login/user/roles');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.userRoleList = result.data;
                    } else {
                        this.userRoleList = [];
                    }
                })
                .catch(error => {
                    this.userRoleList = [];
                    defaultApiErrorHandler.call(this, error);
                });
        },
        queryUserAccessLogList(loading) {
            this.userAccessLogQueryForm.currentPage = 1;
            this.userAccessLogQueryForm.accessUserId = this.loginUser.userId;
            this.doQueryUserAccessLogList(loading);
        },
        doQueryUserAccessLogList(loading) {
            this.userAccessLogQuering = true;
            if (loading) {
                this.userAccessLogLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.userAccessLogQueryForm,
                    mapSort(this.userAccessLogQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of(
                            '/api/platform/login/user/accesslog/list'
                        ),
                        {
                            params: params
                        }
                    )
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.userAccessLogList = result.data;
                            this.userAccessLogQueryTotal = result.totalRowCount;
                        } else {
                            this.userAccessLogList = [];
                            this.userAccessLogQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.userAccessLogList = [];
                        this.userAccessLogQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.userAccessLogLoading = false;
                        }
                        this.userAccessLogQuering = false;
                    });
            }, loading);
        },
        resetUserAccessLogQueryForm() {
            this.$refs.userAccessLogQueryForm.resetFields();
        },
        onUserAccessLogQuerySortChange(parameter) {
            if (
                this.userAccessLogQuerySort.prop != parameter.prop ||
                this.userAccessLogQuerySort.order != parameter.order
            ) {
                this.userAccessLogQuerySort.prop = parameter.prop;
                this.userAccessLogQuerySort.order = parameter.order;
                this.queryUserAccessLogList(1000);
            }
        },
        onUserAccessLogQueryCurrentPageChange(currentPage) {
            this.userAccessLogQueryForm.currentPage = currentPage;
            this.doQueryUserAccessLogList(1000);
        },
        onUserAccessLogQueryPageSizeChange(pageSize) {
            this.userAccessLogQueryForm.pageSize = pageSize;
            this.queryUserAccessLogList(1000);
        }
    }
};
</script>

<style lang="scss">
.admin-userhome-usercard {
    display: block;
    position: relative;
    box-sizing: border-box;
    margin: 15px;
    padding: 0 0 0 25px;

    img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0;
        border: 0 none;
        height: 80px;
        width: 80px;
        border-radius: 50%;
    }
    h3 {
        display: block;
        padding: 0 0 0 90px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 24px;
        height: 40px;
        line-height: 20px;
        font-weight: 500;
    }
    h5 {
        display: block;
        padding: 0 0 0 90px;
        margin-top: 10px;
        height: 40px;
        font-size: 16px;
        line-height: 60px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.35);
    }
}
.admin-userhome-infobox {
    display: block;
    position: relative;
    box-sizing: border-box;
    margin: 15px;
    border-radius: 5px;
    background-color: $--color-primary;
    color: #fff;

    h3 {
        display: inline-block;
        width: 100%;
        padding: 0 0 0 30%;
        margin: 0;
        height: 40px;
        line-height: 50px;
        font-size: 20px;
        font-weight: 500;
    }
    span {
        display: inline-block;
        width: 100%;
        padding: 0 0 0 30%;
        height: 40px;
        line-height: 30px;
        font-size: 24px;
        font-weight: 500;
    }
    i {
        display: block;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 32px;
    }
}
</style>